// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DotLoader__container-acfeb2 {
  display: flex;
}

@keyframes DotLoader__blink-f48600 {
  0% {
    opacity: 0.4;
    transform: scale(1);
  }
  20% {
    opacity: 1;
    transform: scale(1.68);
  }
  50% {
    opacity: 1;
    transform: scale(1.68);
  }
  70% {
    opacity: 0.4;
    transform: scale(1);
  }
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
}
.DotLoader__item-dd3c38 {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 2px;
  background-color: var(--base-80);
  opacity: 0.4;
  animation-name: DotLoader__blink-f48600;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  transform-origin: center center;
}

.DotLoader__item-1-b09b22 {
  animation-delay: 0s;
}

.DotLoader__item-2-c5a0b6 {
  animation-delay: 0.2s;
}

.DotLoader__item-3-ac94ae {
  animation-delay: 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/main/components/GroupStatus/DotLoader/DotLoader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE;IACE,YAAA;IACA,mBAAA;EACF;EACA;IACE,UAAA;IACA,sBAAA;EACF;EACA;IACE,UAAA;IACA,sBAAA;EACF;EACA;IACE,YAAA;IACA,mBAAA;EACF;EACA;IACE,YAAA;IACA,mBAAA;EACF;AACF;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EAEA,uCAAA;EACA,wBAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,qBAAA;AADF","sourcesContent":[".container {\n  display: flex;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0.4;\n    transform: scale(1);\n  }\n  20% {\n    opacity: 1;\n    transform: scale(1.68);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.68);\n  }\n  70% {\n    opacity: 0.4;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0.4;\n    transform: scale(1);\n  }\n}\n\n.item {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  margin: 2px;\n  background-color: var(--base-80);\n  opacity: 0.4;\n\n  animation-name: blink;\n  animation-duration: 1.4s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: both;\n  transform-origin: center center;\n}\n\n.item-1 {\n  animation-delay: 0s;\n}\n\n.item-2 {\n  animation-delay: 0.2s;\n}\n\n.item-3 {\n  animation-delay: 0.4s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DotLoader__container-acfeb2`,
	"item": `DotLoader__item-dd3c38`,
	"blink": `DotLoader__blink-f48600`,
	"item-1": `DotLoader__item-1-b09b22`,
	"item1": `DotLoader__item-1-b09b22`,
	"item-2": `DotLoader__item-2-c5a0b6`,
	"item2": `DotLoader__item-2-c5a0b6`,
	"item-3": `DotLoader__item-3-ac94ae`,
	"item3": `DotLoader__item-3-ac94ae`
};
module.exports = ___CSS_LOADER_EXPORT___;
